import React, { useState,useEffect } from 'react';
import * as S from './HOBTimeWidgetStyles';
import DateTimeFooter from '@React_UI_Lib/DateTimeFooter';
import DateTimePicker from '@React_UI_Lib/DateTimePicker';
import dateFormat from 'dateformat';
import { HOB_BACK_ICON_URL, MONTHS } from '../../../../../config/constants';

const PICKUP = 'pickUp';
const timeErrorDateFormat = 'mmm dd hh:mm TT';

const DateAndTime = ({
  minimumPickupDate,
  time,
  onDonePressed,
  onBackPressed,
  setShowDateTime
}: {
  onDonePressed: () => void;
  onBackPressed: () => void;
  minimumPickupDate:Date,
  time: '';
  setShowDateTime: any
}) => {

  const [isInValidDate, setIsInValidDate] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isDataReady, setIsDataReady] = useState(false);
  const [changedDateTime, setChangedDateTime] = useState(new Date());

  const unsetErrorMessageWithDelay = () => {
    setTimeout(() => {
      setErrorMessage(null);
    }, 4000);
  };

  useEffect(() => {
    if (errorMessage) {
      unsetErrorMessageWithDelay();
    }
  }, [errorMessage]);

  const pickupTimeErrorMessage = () => {
    return `Minimum pickup time should be ${dateFormat(
      minimumPickupDate,
      timeErrorDateFormat
    )}`;
  };

  /**
 * Updates the selected pickup date if it's valid, setting an error message otherwise.
 * @param {Date} newDate - The new date to set as the selected pickup date.
 * @returns {void} Returns undefined.
 */
  const updatePickupDate = (newDate: Date) => {
    if (newDate < minimumPickupDate) {
      setErrorMessage(pickupTimeErrorMessage());
      unsetErrorMessageWithDelay();
    }
    setChangedDateTime(newDate)
  };

  /**
 * Extracts date and time information from a Date object and determines the hour in 12-hour format with AM/PM.
 * @param {Date} date - The Date object from which to extract information.
 * @returns {object} An object containing date and time information: day, month, year, hour, minute, and ampm (AM/PM indicator).
 */
  const dateTimeInfo = (date: Date) => {
    const isHourGreaterThan12 = date?.getHours() >= 12;
    return {
      day: date?.getDate(),
      month: date?.getMonth(),
      year: date?.getFullYear(),
      hour: isHourGreaterThan12
        ? date?.getHours() === 12
          ? 12
          : date?.getHours() - 12
        : date?.getHours(),
      minute: date?.getMinutes(),
      ampm: isHourGreaterThan12 ? 'PM' : 'AM'
    };
  };

  const pickUpDetail = {
    label: 'PICK UP DATE & TIME',
    subInfo: `${String(dateTimeInfo(changedDateTime)['day'])?.padStart(
      2,
      '0'
    )} ${MONTHS[dateTimeInfo(changedDateTime)['month']]} ${
      dateTimeInfo(changedDateTime)['year']
    } - ${String(dateTimeInfo(changedDateTime)['hour'])?.padStart(
      2,
      '0'
    )}:${String(dateTimeInfo(changedDateTime)['minute'])?.padStart(2, '0')} ${
      dateTimeInfo(changedDateTime)['ampm']
    }`
  };

  const onDoneClick=()=>{
    setShowDateTime(changedDateTime.getTime().toString())
    onDonePressed();
  }

  useEffect(() => {
    const fetchData = async () => {
      setChangedDateTime(new Date(parseFloat(time)));
      setTimeout(() => {
        setIsDataReady(true);
      },10);
    };
    fetchData();
  }, []);

  return (
    <S.DateAndTimeContainer>
      <S.DateAndTimeHeader>
        <S.DateAndTimeWrapper>
          <img
            className="BackIc"
            src={HOB_BACK_ICON_URL}
            onClick={onBackPressed}
          />
          <span>Select Travel Date & Time</span>
        </S.DateAndTimeWrapper>
      </S.DateAndTimeHeader>
      {isDataReady && (
      <DateTimePicker
        minDate={minimumPickupDate}
        date={changedDateTime}
        onDateChange={updatePickupDate}
        setIsInValidDate={setIsInValidDate}
        isInValidDate={isInValidDate}
        isPickUpActive={true}
        isActive={PICKUP}
        dtDateLabel={'*Pick Up Date*'}
        dtTimeLabel={'*Pick Up Time*'}
      />)
      }
      {errorMessage ? (
        <S.ErrorMessageBox>
          {errorMessage}
        </S.ErrorMessageBox>
      ) : null}
      <DateTimeFooter
        pickUpDetail={pickUpDetail}
        dropDetail={null}
        isPickUpActive={true}
        isDisable={isInValidDate ? PICKUP : null}
        onBtnClick={() => {
          onDoneClick();
        }}
        isBtnDisable={isInValidDate ? true : false}
        btnTxt="Done"
      />
    </S.DateAndTimeContainer>
  );
};

export default DateAndTime;
